import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import "./index.css";
import { initSentry } from "./lib/sentry";
import { startVersionCheck } from "./lib/version-checker";

// 🎯 PREMIUM V3.0 PORTAL - Complete UX Overhaul
const PREMIUM_VERSION = 'v3.0.0-portal-2026-01-27-1145';
console.clear();
console.info(
  '%c🚀 PREMIUM V3.0 PORTAL',
  'background: linear-gradient(135deg, #009544 0%, #00b855 100%); color: white; padding: 16px 32px; font-size: 18px; font-weight: bold; border-radius: 12px; text-shadow: 0 2px 8px rgba(0,0,0,0.3);',
  {
    version: PREMIUM_VERSION,
    buildTime: '2026-01-27 11:45',
    mode: import.meta.env.MODE,
    features: {
      toolbar: 'Location + Search Integrated',
      persistence: 'localStorage State',
      zIndex: 'Portal-Grade System',
      scan: 'Optimized Card Hierarchy',
      darkGlass: 'ENABLED',
      premiumShadows: 'ENABLED'
    }
  }
);

// Sentry initialisieren (muss VOR React-Rendering sein)
initSentry();

// Version Checker starten (Auto-Reload bei neuer Version)
startVersionCheck();

// ═══════════════════════════════════════════
// IMAGE PROTECTION: Prevent download/save-as
// ═══════════════════════════════════════════
if (typeof document !== 'undefined') {
  // Block right-click context menu on images
  document.addEventListener('contextmenu', (e) => {
    const target = e.target as HTMLElement;
    if (
      target.tagName === 'IMG' || 
      target.closest('.protected-image') ||
      target.closest('[role="img"]')
    ) {
      e.preventDefault();
      return false;
    }
  }, true);

  // Block drag on images
  document.addEventListener('dragstart', (e) => {
    const target = e.target as HTMLElement;
    if (target.tagName === 'IMG') {
      e.preventDefault();
      return false;
    }
  }, true);
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
